// extracted by mini-css-extract-plugin
export var component = "HeaderMainMenu-module--component--Pclev";
export var hidden = "HeaderMainMenu-module--hidden--Wtmfz";
export var isCentered = "HeaderMainMenu-module--isCentered--asbiy";
export var item = "HeaderMainMenu-module--item--RfNax";
export var link = "HeaderMainMenu-module--link--QLrK7";
export var list = "HeaderMainMenu-module--list--6KF5t";